import classNames from 'classnames';
import { t } from '../../common/components/T';
import { getIsSafari } from '../../common/utils/utils';

export const colors = [
    'var(--gold700Color)',
    'var(--gold600Color)',
    'var(--gold400Color)',
    'var(--gold300Color)',
    'var(--gold200Color)',
    'var(--goldColor)'
];

export const skeletonElements = () => {
    return [
        {
            row: [30, 50, 20],
            items: [
                {
                    content: [
                        {
                            type: 'title'
                        },
                        {
                            type: 'text',
                            width: 80
                        }
                    ]
                },
                'empty',
                {
                    type: 'circle',
                    align: 'right',
                    diameter: 3
                }
            ],
            vertical: 'unset'
        },
        {
            row: [24, 19, 19, 19, 19],
            items: ['blockXL', 'blockLG', 'blockLG', 'blockLG', 'blockLG'],
            gap: 1,
            vertical: 'end'
        },
        'empty',
        'chart'
    ];
};

export const createWidgetData = (data = {}, translation, currencies, periods) => {
    if (!Array.isArray(data?.data)) return null;
    const currency =
        (currencies?.data && currencies?.data?.find((curr) => curr?.id === data?.meta?.filter?.default_currency)) || {};
    const period = {
        start: +data?.meta?.filter?.marketing_period_id_from,
        end: +data?.meta?.filter?.marketing_period_id_to,
        currency_id: data?.meta?.filter?.default_currency,
        start_formatted: data?.meta?.filter?.marketing_period_from?.id_formatted,
        end_formatted: data?.meta?.filter?.marketing_period_to?.id_formatted
    };
    let allSum = data.data.reduce((accum, item) => (accum += Number(item?.amount)), 0);
    const bonuses = (data?.meta?.bonuses || []).map((bonus) => {
        const sum = data?.data?.reduce((accum, item) => {
            if (+item.marketing_bonus_id === bonus.id) {
                accum += +item?.amount;
            }
            return accum;
        }, 0);
        return {
            ...bonus,
            amount: sum.toLocaleString()
        };
    });

    const periodsFiltered = periods?.slice(
        periods.findIndex((per) => +per.id === period.start),
        periods.findIndex((per) => +per.id === period.end) + 1
    );
    const isSafari = getIsSafari();
    const categories = periodsFiltered.map((per) => per?.id_formatted);
    return {
        allSum,
        period,
        bonuses,
        config: {
            allowChartUpdate: true,
            options: {
                title: false,
                chart: {
                    type: 'column',
                    className: classNames('dynamic-rewards', isSafari && 'dynamic-rewards-safari'),
                    reflow: true
                },
                legend: {
                    enabled: false
                },
                xAxis: {
                    categories
                },
                yAxis: {
                    min: 0,
                    title: { text: null },
                    gridLineColor: '#CCC',
                    gridLineDashStyle: 'Dash'
                },
                colors,
                plotOptions: {
                    column: {
                        borderRadius: 5,
                        pointWidth: 8
                    }
                },
                series: data?.meta?.bonuses?.map((bonus) => {
                    const dataSeries = categories?.map(
                        (period) =>
                            +data?.data?.find(
                                (item) => item?.period?.id_formatted === period && +bonus.id === +item?.marketing_bonus_id
                            )?.amount || 0
                    );
                    return {
                        name: bonus?.name + ` - ${t('bonus-lowercase', 'бонус', 'all', translation)}`,
                        data: dataSeries
                    };
                }),
                tooltip: {
                    style: {
                        fontFamily: 'inherit'
                    },
                    crosshairs: true,
                    shared: true,
                    borderRadius: 0,
                    borderWidth: 0,
                    shadow: false,
                    enabled: true,
                    backgroundColor: 'white',
                    useHTML: true,
                    headerFormat: `<div class="dynamic-rewards-header"><span class="dynamic-rewards-header-label">${t(
                        'calculation_week',
                        'Расчетная неделя',
                        '/office',
                        translation
                    )}: <span class="dynamic-rewards-header-value">{point.key}</span></span></div>`,
                    pointFormat: `<div class="dynamic-rewards-item">
                        <div class="dynamic-rewards-item-circle" style="background-color: {series.color}"></div>
                        <div class="dynamic-rewards-info">
                            <p class="dynamic-rewards-name">{series.name}</p>
                            <p class="dynamic-rewards-value">{point.y} ${currency?.symbol || 'PV'}</p>
                        </div>
                    </div>`
                }
            }
        }
    };
};
